<template>
	<div class="dingjin-container">
		<!-- 下定金 -->
		<van-popup
			:closeOnClickOverlay="false"
			class="applyform-content dingpricevlog"
			v-model="showDingform"
			position="bottom"
			round
			:showConfirmButton="false"
			:style="{ height: '620px' }"
		>
			<div class="title">我要下定金</div>
			<div class="good-desc" style="padding: 0">
				<div class="good-img">
					<img :src="goodDetail.pic_list[0]" alt="" />
				</div>
				<div class="good-name">
					<span style="font-size: 14px; font-weight: 550">{{ goodDetail.name }}</span>
				</div>
			</div>
			<div class="good-type" style="margin-top: 10px">
				<span>{{ goodDetail.product_type }}</span>
			</div>
			<van-form @submit="onSubmitQuery">
				<van-field 
					style="margin-top: 10px"
					border
					v-model="selectedModelText"
					name="型号"
					placeholder="请选择购机型号"
					readonly
					clickable
					@click="showModelPicker = true"
				/>
				<!--型号选择弹窗-->
				<van-popup v-model="showModelPicker" position="bottom">
					<van-picker 
						:columns="goodDetail.product_type_no"
						@confirm="onConfirmModel"
						@cancel="showModelPicker = false"
						show-toolbar
						title="选择购机型号"
					/>
				</van-popup>
				<van-field style="margin-top: 10px" border v-model="queryinfo.name" minlength="2" maxlength="10" name="用户名" placeholder="您的姓名" />
				<van-field style="margin-top: 10px" border v-model="queryinfo.phone" name="手机号" maxlength="11" placeholder="请输入手机号码" />
				<!-- <van-field border v-model="queryinfo.code" name="验证码" placeholder="请输入">
					<template #button>
						<span @click="getCode" v-if="codeTime >= 60" style="color: #1ea0d9">获取验证码</span>
						<span v-if="codeTime < 60" style="color: #1ea0d9">{{ codeTime }}s后重新获取</span>
					</template>
				</van-field> -->
				<van-field
					style="margin-top: 10px"
					border
					v-model="area"
					readonly
					clickable
					name="地区"
					@click="showQueryArea = true"
					placeholder="所在区域"
				/>
				<!-- <van-field border v-model="agent_name" readonly clickable name="地区" @click="openAgent" placeholder="代理店" /> -->
				<van-field
					style="margin-top: 10px"
					border
					type="textarea"
					v-model="queryinfo.address"
					name="详细地址"
					placeholder="请输入详细地址"
					rows="2"
					autosize
				/>
				<van-checkbox v-model="checked" plain checked-color="#1ab4ec" style="margin-top: 8px;">
					<span style="color: #1ab4ec;" @click.stop="showPrivacy = true">隐私政策</span> & <span style="color: #1ab4ec;" @click.stop="showService = true">服务协议</span>
				</van-checkbox>
				<div>
					<van-button native-type="submit" :disabled="!goodDetail || goodDetail.unit === 0" class="button">支付 {{ goodDetail.price }}订金(剩余库存{{ goodDetail.unit }}台)</van-button>
				</div>
			</van-form>
			<div class="applyformdelicon" @click="closeshowdingform"><van-icon name="cross" /></div>
			<!-- <div class="buttom">客服代表将尽快与您联系，请保持通讯通畅！</div> -->
		</van-popup>
		<van-popup v-model="showQueryArea" position="bottom">
			<van-area :area-list="areaList" @confirm="onConfirm" @cancel="showQueryArea = false" />
		</van-popup>
		<!--隐私协议-->
		<van-popup
			v-model="showPrivacy"
			closeable
			close-icon="close"
			position="bottom"
			:style="{ height: '90%' }"
			overlay-class="privacy-popup"
			class="privacy_popup"
			@close="handlePrivacyClose"
		>
			<h1>隐私政策</h1>
			<p>久保田农业机械（苏州）有限公司顾客个人信息保护基本方针</p>
			<p>久保田农业机械（苏州）有限公司(以下简称“苏州久保田”)、苏州久保田认定的经销商（以下简称 “苏州久保田经销商”）及其各自的关联公司（包括但不限于其各自的母公司、农机的制造公司及久保田（中国）投资有限公司）（以下将“苏州久保田”、“苏州久保田经销商”及其各自的关联公司统称为“苏州久保田”）认为严格遵守个人信息保护相关的中国法律法规，妥善处理顾客个人姓名、地址、电话号码、邮箱地址等能够识别顾客个人及其家庭成员身份的信息（以下简称“个人信息”），是企业重要的社会责任。基于此，“苏州久保田”制定了如下的保护个人信息基本方针。</p>
			<div class="texts">
				<h2>1.个人信息的取得</h2>
				<h3>1)“苏州久保田”于以下情形取得个人信息：</h3>
				<h5>① 销售产品、提供服务时取得的个人信息</h5>
				<h5>② 为了提供问询对应等取得的个人信息（包括使用来电显示取得的联系方式）；</h5>
				<h5>③ 实施各项调查（包括“苏州久保田”委托外部公司实施的）时取得的个人信息； </h5>
				<h5>④ “苏州久保田”取得的其他个人信息。</h5>
				<h3>2)“苏州久保田”将在取得顾客的同意后，取得其个人信息。</h3>
			</div>
			<div class="texts">
				<h2>2.个人信息的处理</h2>
				<h3>1）关于个人信息的使用</h3>
				<h4>“苏州久保田”根据前述第1.条规定取得的个人信息，将仅在“苏州久保田”内部根据需要进行共享，并且仅为以下目的或其他合法、正当的目的使用：</h4>
				<h5>① 与顾客进行的交易；</h5>
				<h5>② 商品及服务的企划、开发、改善；</h5>
				<h5>③ 发送与“苏州久保田”的产品、服务、宣传活动（包括但不限于农机、保险等）相关的信息或通知；（但在未取得顾客同意的情况下，我们不会发送商业性目的的上述信息或通知）</h5>
				<h5>④ 在产品企划、开发或提高服务质量及顾客满意度等方面，实施的各项调查；</h5>
				<h5>⑤ 顾客问询、联系“苏州久保田经销商”及服务热线时，进行迅速的对应；</h5>
				<h5>⑥ 根据法律规定或政府机关、法院、调解机构、仲裁机构等的通知、指导等而采取的对应； </h5>
				<h5>⑦ 其他取得个人信息时所明示的使用目的</h5>
				<h3>2）向第三方提供个人信息</h3>
				<h4>“苏州久保田”根据前述第1.条规定取得的个人信息，在未取得顾客同意的情况下，不会向第三方提供或出售。但是，为了实现上述使用目的，在必要的范围内，会提供给业务受托方。于此情形下，“苏州久保田”会要求业务受托方妥当处理“苏州久保田”所提供的个人信息，并进行妥善管理。</h4>
				<h3>3）妥善管理个人信息 </h3>
				<h4>为了对个人信息严格保密，防止不正当接触个人信息，防止个人信息丢失、损坏、被篡改、泄露等，“苏州久保田”采取了妥善的安全措施，并且将在因前述事由导致事故后采取救济措施。</h4>
			</div>
			<div class="texts">
				<h2>3.问询等</h2>
				<h4>关于个人信息的相关问询，请就近联系“苏州久保田经销商”或“苏州久保田服务热线”。“苏州久保田”将严格遵守个人信息保护相关的中国法律法规，进行妥善处理。</h4>
				<h4>•关于就近的“苏州久保田经销商”</h4>
				<h4>【https://www.kubota.com.cn】</h4>
				<h4>•“苏州久保田服务热线”</h4>
				<h4>【电话：400-923-3322】</h4>
			</div>
			<div class="texts">
				<h2>4.遵纪守法与改善</h2>
				<h4>“苏州久保田”将严格遵守个人信息保护相关的中国法律法规，并为了妥善处理个人信息而进行持续性的改善，并会将改善内容随时体现在本基本方针中。</h4>
			</div>
		</van-popup>
		<!--服务协议-->
		<van-popup
			v-model="showService"
			closeable
			close-icon="close"
			position="bottom"
			:style="{ height: '90%' }"
			overlay-class="service-popup"
			class="service_popup"
			@close="handleServiceClose"
		>
			<h1>苏州久保田手机网站服务协议</h1>
			<p>欢迎您使用久保田农业机械（苏州）有限公司（以下简称“苏州久保田”）运营的手机网站：http:// www.kubota.com.cn （以下简称“苏州久保田手机网站”或“本网站”）提供的互联网信息服务及相关的软件、技术支持的电子商务平台服务。本用户服务协议（以下简称“本协议”）由您（以下或称“用户”）与苏州久保田共同缔结，具有合同效力，并适用于苏州久保田提供的所有网络服务。</p>
			<div class="texts">
				<h2>一、协议内容及范围</h2>
				<h3>（一）本协议的内容包括协议正文及所有由苏州久保田将来可能发布的各类规则，包括苏州久保田根据业务需要不时更新发布的修改版本。除非另有明确说明，下文中所称的本协议，其含义均应按照上述表述理解。除另行明确声明外，使用本网站平台提供的服务均受本协议约束。</h3>
				<h3>（二）请您在使用苏州久保田手机网站提供的网络服务前认真阅读本协议各条款内容，免除或限制责任的条款将以粗体下划线标示，请您重点阅读。如您为无民事行为能力人或限制民事行为能力人，请在您监护人的指导下阅读本协议。如您完成全部注册程序、使用苏州久保田手机网站提供的网络服务时，即表示您已阅读、理解、同意并接受本协议全部条款的约束。</h3>
				<h3>（三）本网站平台有权根据互联网发展需求不定期地修改更新本协议，请您留意关注。如您不同意相关修改，可随时自主选择停止使用本网站平台服务。若您在本协议的修改版本公示3日后，仍继续使用本网站平台服务的，即表示您已经了解并完全接受本协议的修改版本。</h3>
			</div>
			<div class="texts">
				<h2>二、本网站平台服务使用规范</h2>
				<h3>（一）在使用本网站平台服务过程中，您承诺遵守以下约定：</h3>
				<h5>1.您应当具有中华人民共和国法律规定的与您使用本网站平台的行为相适应的民事行为能力。</h5>
				<h5>2.您在使用本网站平台服务过程中实施的所有行为均应遵守国家法律法规之规定，并应不违背社会公共利益及公共道德，不损害他人的合法权益。</h5>
				<h5>3.不对本网站平台上的任何信息和数据做商业性利用，包括但不限于在未经本网站平台事先书面同意的情况下，以复制、传播等任何方式使用本网站平台上展示的信息、数据等。</h5>
				<h5>4.不使用任何装置、软件或例行程序干预或试图干预本网站平台的正常运作或正在本网站平台上进行的任何兑换、交易或活动。禁止采取任何将导致不合理的庞大数据负载加诸于本网站平台设备的行为。</h5>
				<h3>（二）在本网站平台使用服务过程中，您已了解并同意：</h3>
				<h5>1.本网站平台有权对您是否违反上述承诺做出认定，并根据认定结果予以相应处理（包括但不限于中止、终止向您提供服务）。在终止服务时，本网站平台将会以短信或站内信的方式通知您，若您在获得通知后3日内未以有效的方式向本网站平台提出异议，即表示您已接受该认定及服务终止。</h5>
				<h5>2.对于用户在本网站平台上发布的涉嫌违法、侵权或违反本协议约定的信息，本网站平台将会以短信或站内信的方式告知后即予以删除，且保留追究其法律责任的权利。</h5>
				<h5>3.对于您在本网站平台上实施的行为，或虽未在本网站平台上实施但已经对平台及其他用户产生影响的行为，本网站平台有权认定您行为的性质及是否构成对本协议的违反，并保留追究法律责任的权利。</h5>
				<h5>4.如用户涉嫌违反法律法规或本协议约定的行为对任意第三方造成损害的，该用户应当以自己的名义独立承担全部法律责任，并应确保本网站平台免于因此遭受损失或增加费用支出。</h5>
				<h5>5.如用户涉嫌违反法律法规或者本协议约定的行为，使本网站平台遭受任何损失，或遭到任何第三方的索赔，或受到任何行政管理部门的处罚的，该用户应当赔偿因此给本网站平台造成的损失及（或）发生的费用，包括但不限于赔偿金、罚款、声誉损失、诉讼费、律师费用等。</h5>
			</div>
			<div class="texts">
				<h2>三、第三方广告及内容</h2>
				<h3>（一）本网站平台在提供服务过程中有权通过各种方式投放各种商业性广告或其他任何类型的商业信息，您有权通过您注册时填写的手机号码或其他联系方式获取本网站平台向您发送的商品促销或其他相关商业信息。如您不愿意接收此类信息，您有权通过相应的设置功能进行退订。</h3>
				<h3>（二）本网站平台提供的第三方（包括苏州久保田授权经销商及其他第三方）内容或通往第三方的链接，均由第三方自行发布，并由该第三方向您提供该产品的升级、维护、客服等后续工作，本网站平台无法逐一审查，您应当对该第三方的产品及服务信息自行甄别并承担风险。对于您经本网站平台向第三方购买、取得的任何第三方产品或服务，由该第三方对其产品的质量及服务问题承担全部责任，您了解并同意应向第三方主张与此相关的一切权利。</h3>
				<h3>（三）您明确知悉并同意，根据实际情况变化，苏州久保田有权对本网站平台上的商品信息、车辆使用相关信息进行修改和更新，并可对此不作特别通知。苏州久保田秉承初心，为使网站内展示的商品参数、说明、价格、库存等商品信息及车辆使用相关信息尽可能准确、详尽、完整而不懈追求极致完美，但受限于互联网技术的发展水平等因素，相关信息可能会有一定的滞后或误差，您对此情形已充分知悉并完全理解，对于可能给您造成的损失或损害，苏州久保田不承担任何赔偿责任。</h3>
			</div>
			<div class="texts">
				<h2>四、责任范围和责任限制</h2>
				<h3>（一）本网站平台将竭尽最大努力对服务水平进行不断优化完善，但我们无法保证本网站平台服务在适用性、持续性、准确性、可靠性等方面不存在任何错误或疏漏。</h3>
				<h3>（二）除非法律法规明确要求，或出现以下情况，否则，本网站平台没有义务对所有用户的注册数据、商品（服务）信息、商品兑换行为以及与交易有关的其它事项进行事先审查：</h3>
				<h5>1.本网站平台有合理的理由认为特定用户及具体交易事项可能存在重大违法或违约情形的。</h5>
				<h5>2.本网站平台接到执法部门关于协助调查等的要求的。</h5>
				<h3>（三）您了解并同意，本网站平台不对因下述任一情况而导致您的任何损害承担责任（包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失，无论本网站平台是否已被告知该等损害赔偿的可能性）：</h3>
				<h5>1.使用或未能使用本网站平台服务。</h5>
				<h5>2.第三方未经批准使用您的账户或更改您的信息数据。</h5>
				<h5>3.通过本网站平台服务兑换或获取任何商品、数据、信息或进行交易等行为或替代行为所产生的费用及损失。</h5>
				<h5>4.用户对本网站平台服务的误解。</h5>
				<h5>5.接受第三方提供的服务或产品而造成的纠纷或损失。</h5>
				<h5>6.任何非因本网站平台的原因而引起的与本网站平台服务有关的其它损失。</h5>
				<h3>（四）因以下原因导致本网站平台不能提供服务或延迟提供服务，本网站平台免予承担责任：</h3>
				<h5>1.信息网络正常的设备维护或升级；</h5>
				<h5>2.信息网络连接故障，电脑、通讯或其他系统的故障，电力故障；</h5>
				<h5>3.地震、火灾、洪水、雷电、风暴、台风、爆炸、战争、罢工、劳动争议、暴乱、起义、骚乱、恐怖袭击、生产力或生产资料不足等不可抗力；</h5>
				<h5>4.政府行为、司法行政机关的命令等；</h5>
				<h5>5.病毒、木马、恶意程序攻击等第三方的作为或不作为。</h5>
			</div>
			<div class="texts">
				<h2>五、协议终止</h2>
				<h3>（一）如您在使用本网站平台的过程中违反本协议约定，本网站平台有权进行调查、中止或终止向您提供部分或全部本网站平台服务，暂时或永久冻结、注销您的账户，且无须为此向您或任何第三方承担任何责任。如因此造成本网站平台或任何第三方损失的，您应以自己的名义自行承担相关法律责任。在中止、终止服务前，本网站平台将会以短信或站内信的方式通知您，若您在通知后3日内未以有效的方式向我们提出异议，即表示您已接受本网站平台所进行的处理。</h3>
				<h3>（二）出现以下情况时，本网站平台有权直接以注销账户的方式终止本协议：</h3>
				<h5>1.用户死亡；</h5>
				<h5>2.注册用户时提供虚假信息（包括且不限于：盗用他人的个人信息或手机号码；使用非本人所有的实名登记手机号码；使用非本人购买或有权使用的车辆信息）；</h5>
				<h5>3.以非法手段（包括且不限于黑客攻击、使用外挂等）来积累或使用优惠；</h5>
				<h5>4.妨碍其他用户的正常使用；</h5>
				<h5>5.伪称是苏州久保田的工作人员或管理人员；</h5>
				<h5>6.擅自更改苏州久保田的计算机系统，或威胁侵入系统；</h5>
				<h5>7.擅自传播谣言，用各种手段来诋毁苏州久保田的名誉或妨碍苏州久保田或其经销商的正常营业；</h5>
				<h5>8.利用苏州久保田的产品及服务宣传垃圾广告；</h5>
				<h5>9.用户擅自更改、消除或毁损苏州久保田广告业务提供的各种信息；</h5>
				<h5>10.利用技术手段批量建立虚假账号；</h5>
				<h5>11.侵害苏州久保田以及第三者的知识产权；</h5>
				<h5>12.提交、发布虚假信息，或盗用他人资料、冒充、利用他人名义发布信息；</h5>
				<h5>13.传播淫秽、暴力、毒品、赌博等违法信息；</h5>
				<h5>14.本网站平台终止向用户提供服务后，其用户试图再次直接或间接或以他人名义注册为本网站平台用户；</h5>
				<h5>15.用户提供的手机号码不存在或无法接收信息，且没有其他方式可以与其本人进行联系；或本网站平台以其它联系方式通知用户更改手机号码，而用户在本网站平台通知后三天内仍未更改为有效的手机号码；</h5>
				<h5>16.本协议修改时，用户本人明示并通知本网站平台不愿接受本协议的修改版本；</h5>
				<h5>17.其它违反法律法规、违反本协议约定或本网站平台认为应当终止服务的情况。</h5>
				<h3>（三）用户本人有权向本网站平台要求注销其个人账户，本网站平台审核同意后将注销该账户，届时用户与本网站平台的合同关系即终止。用户账户被注销后，本网站平台没有义务为其保留或披露账户中的任何信息，也没有义务向其或第三方转发任何用户未曾阅读或发送完毕的信息</h3>
				<h3>（四）用户本人与本网站平台达成合意终止本协议后，本网站平台仍享有下列权利：</h3>
				<h5>1.继续保存用户的注册信息及用户使用本网站平台服务期间所有兑换、参与活动及交易信息。</h5>
				<h5>2.如用户在使用本网站平台服务期间存在违法或违反本协议的行为的，本网站平台仍有权向其主张权利、要求其承担相应的赔偿责任。</h5>
			</div>
			<div class="texts">
				<h2>六、隐私权政策</h2>
				<h3>（一）本网站平台将严格遵守中国相关法律法规及苏州久保田顾客隐私及个人信息保护相关方针政策，收集并妥善保存、使用您在使用本网站平台过程中提供的姓名、地址、电话号码、邮箱地址等能够识别您及您家庭成员身份的信息。</h3>
				<h3>（二）本网站平台承诺仅在合法、正当、必要的范围内，在如下情形中使用您的个人信息：</h3>
				<h5>1.与您进行的交易；</h5>
				<h5>2.商品及服务的企划、开发、改善；</h5>
				<h5>3.发送与苏州久保田的产品、服务、宣传活动（包括但不限于农机、保险等）相关的信息或通知（根据本协议第3条，在您设置退订的情况下，本网站平台不会发送商业性目的的上述信息或通知）；</h5>
				<h5>4.在产品企划、开发或提高服务质量及顾客满意度等方面，实施的各项调查；</h5>
				<h5>5.在必要的范围内向本网站平台授权的第三方服务提供者、本网站平台的第三方合作伙伴以及以上各方因向您提供各项服务之需要而委托的合作公司披露，于此情形下，本网站平台会严格督促各关联公司及合作公司遵守相关法律法规及本条约定，妥当保存、处理本网站平台所提供的用户个人信息；</h5>
				<h5>6.依照法律法规或司法、行政机关之要求进行披露；</h5>
				<h5>7.其他苏州久保田顾客隐私及个人信息保护相关方针政策或取得您个人信息时所明示的使用目的。</h5>
			</div>
			<div class="texts">
				<h2>七、法律适用、管辖与其它</h2>
				<h3>（一）本协议之订立、效力、解释、变更、履行与争议解决均适用中华人民共和国法律，如无相关法律规定的，则应参照通用的国际商业惯例和（或）行业惯例。</h3>
				<h3>（二）若本协议的任何条款在任何程度上被认定为无效或不可强制执行，则本协议其余部分不受此影响并应在适用法律允许的最大程度上予以执行。</h3>
				<h3>（三）本协议执行过程中所产生的任何问题，本网站平台和用户之间秉承友好协商的原则进行解决。如因本协议产生之争议，应向苏州久保田所在地有管辖权的人民法院提起诉讼，通过诉讼最终解决争议。</h3>
			</div>
		</van-popup>
	</div>
</template>

<script>
import * as api from "@/api/live";
import { areaList } from "@vant/area-data";
import { checkMobile, checkName } from "@/utils/utils.js";
export default {
	data() {
		return {
			showQueryArea:false,
			showModelPicker: false,
			areaList,
			queryinfo: {
				name: '',
				phone: '',
				province: '',
				city: '',
				county: '',
				rank_user_name: '',
				rank_user_id: '',
				user_id: '',
				address: '',
				invitation_id: '',
				extra1: ''
			},
			area:'',
			selectedModelText: '',
			hasToPAyCount: 0,
			wxJsBridgeReady: false, // 新增：标记WeixinJSBridge是否就绪
			checked: true,
			showPrivacy: false,
			showService: false
		};
	},
	props: {
		showDingform:{
			type: Boolean,
			default:false,
		},
		userId:{
			type: [String, Number],
			default: "",
		},
		live_id:{
			type: [String, Number],
			default: "",
		},
		goodDetail:{
			type:Object,
			default(){
				return {}
			}
		}
	},
	mounted() {
		// 新增：组件挂载时就监听WeixinJSBridgeReady事件（提前监听，避免错过）
		this.initWxJsBridgeListener()
	},
	methods: {
		handlePrivacyClose() {
			this.showPrivacy = false;
		},
		handleServiceClose() {
			this.showService = false;
		},
		// 新增：初始化微信JSBridge监听（页面加载时就执行）
		initWxJsBridgeListener() {
			const _this = this
			// 先判断是否已存在WeixinJSBridge
      if (typeof WeixinJSBridge !== 'undefined') {
        _this.wxJsBridgeReady = true;
        return;
      }
			// 兼容微信的事件绑定方式（覆盖所有微信版本）
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', () => {
          _this.wxJsBridgeReady = true;
        }, false);
      } else if (document.attachEvent) {
        // 兼容低版本IE/微信内置浏览器
        document.attachEvent('onWeixinJSBridgeReady', () => {
          _this.wxJsBridgeReady = true;
        });
      }
		},
		closeshowdingform(){
			this.$emit('closeshowdingform')
			this.resetForm()
		},
		resetForm() {
			this.selectedModelText = ''
			this.area = ''
			this.queryinfo = {
				name: '',
				phone: '',
				province: '',
				city: '',
				county: '',
				rank_user_name: '',
				rank_user_id: '',
				user_id: '',
				address: '',
				invitation_id: '',
				extra1: ''
			}
		},
		onConfirm(values) {
			this.area = values
				.filter((item) => !!item)
				.map((item) => item.name)
				.join("/");
			this.queryinfo.province = values[0].name;
			this.queryinfo.city = values[1].name;
			this.queryinfo.county = values[2].name;
			this.showQueryArea = false;
		},
		onConfirmModel(value) {
			console.log('123',value)
			this.selectedModelText = value
			this.queryinfo.extra1 = value
			this.showModelPicker = false
		},
		// 提交下定金
		onSubmitQuery(values) {
			if (!localStorage.getItem('live_access_token')) {
				this.$toast.fail('请先登录后再支付')
				this.$emit('login')
				return
			}
			if (!this.userId) {
				this.$toast.fail('登录信息异常，请刷新后重试')
				return
			}
			if (!this.queryinfo.extra1) {
				this.$toast({
					message: '<div style="height:40px;width:70px;display:flex;align-items:center;justify-content:center;">请输入购机型号</div>',
					type: 'html',
				})
				return;
			}
			
			if (!this.queryinfo.name) {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justify-content:center">请填写姓名</div>',
					type: "html",
				});
				return;
			}

			// if (!checkName(this.queryinfo.name)) {
			// 	this.$toast({
			// 		message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写2-6位汉字姓名</div>',
			// 		type: "html",
			// 	});
			// 	return;
			// }
			
			if (!this.queryinfo.phone) {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justify-content:center">请填写手机号</div>',
					type: "html",
				});
				return;
			}
			if (!checkMobile(this.queryinfo.phone)) {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justify-content:center">请填写正确手机号</div>',
					type: "html",
				});
				return;
			}
			// if (!this.queryinfo.code) {
			// 	this.$toast.fail("验证码不能为空");
			// 	return;
			// }
			if (!this.area) {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justify-content:center">地区不能为空</div>',
					type: "html",
				});
				return;
			}
			if (!this.queryinfo.address) {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justify-content:center">请输入详细地址</div>',
					type: "html",
				});
				return;
			}
			this.queryinfo.liveid = this.live_id;
			this.queryinfo.productid = this.goodDetail.id;
			this.queryinfo.user_id = this.userId;
			// 附带 token，服务端以 JWT 用户为准覆盖 user_id，防止邀请串号
			this.queryinfo.token = localStorage.getItem('live_access_token') || '';

			console.log('this.queryinfo.user_id',this.queryinfo.user_id)			

			this.hasToPAyCount = this.hasToPAyCount + 1

			console.log("提交下定金", this.queryinfo);

			api.goodmakeorder(this.queryinfo).then((res) => {
				console.log('下定金接口数据', res)
				const reg = /^1\d{10}$/;
				if (res.code === 200) {
					this.$toast.success(res.message)
					// this.onBridgeReady(res.result)
					// 调用优化后的支付方法
          this.handleWxPay(res.result)
				} else if (res.code === 4001) {
					this.$toast.fail(res.message || '请重新登录')
					this.$emit('login')
				} else {
					this.$toast.fail(res.message || '下单失败，请重试')
				}
			}).catch((err) => {
				console.log('下单失败', err)
				const msg = (err && err.message) ? String(err.message) : ''
				if (msg.indexOf('未登录') !== -1 || msg.indexOf('授权') !== -1) {
					this.$emit('login')
				}
				this.$toast.fail(msg || '网络错误，请重试')
			});
		},
		// 优化：微信支付核心逻辑（适配微信内的情况）
		handleWxPay(payParams) {
			const that = this;
      // 先检测是否为微信环境（双重保障）
      // const isWechat = /MicroMessenger/i.test(navigator.userAgent);
      // if (!isWechat) {
      //   that.$toast.fail('请在微信内置浏览器中完成支付');
      //   return;
      // }
			const doPay = () => {
				try {
          WeixinJSBridge.invoke('getBrandWCPayRequest', {
            appId: payParams.appId,       // 注意：参数名小写（部分后端返回AppId，需统一）
            timeStamp: payParams.timeStamp + '', // 必须是字符串！（微信要求，数字会报错）
            nonceStr: payParams.nonceStr,
            package: payParams.package,   // 注意：package参数值必须是prepay_id=xxx格式
            signType: payParams.signType || 'MD5',
            paySign: payParams.paySign
          }, function(res) {
            // 微信支付回调状态说明
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              that.$toast.success('支付成功');
							that.$emit('refreshGoodDetail')
              that.closeshowdingform();
              that.changeHandler();
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
              that.$toast.fail('您取消了支付');
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              that.$toast.fail('支付失败：' + (res.err_desc || '请稍后重试'));
            } else {
              that.$toast.fail('支付异常：' + res.err_msg);
            }
          });
        } catch (e) {
          console.error('微信支付执行异常：', e);
          that.$toast.fail('支付接口调用失败，请稍后重试');
        }
			}
			// 核心：根据JSBridge状态执行支付
      if (this.wxJsBridgeReady) {
        // 已就绪，直接支付
        doPay();
      } else {
        // 未就绪，等待事件触发后再支付（最多等5秒，避免卡死）
        let waitCount = 0;
        const timer = setInterval(() => {
          waitCount++;
          if (that.wxJsBridgeReady) {
            clearInterval(timer);
            doPay();
          } else if (waitCount >= 50) { // 5秒超时（50*100ms）
            clearInterval(timer);
            that.$toast.fail('微信支付接口加载超时，请刷新页面重试');
          }
        }, 100);
      }
		},
		onBridgeReady(result) {
			const that = this
			WeixinJSBridge.invoke('getBrandWCPayRequest', {
				"appId": result.appId,     //公众号ID，由商户传入     
				"timeStamp": result.timeStamp,     //时间戳，自1970年以来的秒数     
				"nonceStr": result.nonceStr,      //随机串     
				"package": result.package,
				"signType": result.signType,     //微信签名方式：     
				"paySign": result.paySign //微信签名 
			},
			function(res) {
				if (res.err_msg == "get_brand_wcpay_request:ok") {
					that.$toast.success('支付成功')
					that.closeshowdingform()
					that.changeHandler()
				} else {
					that.$toast.fail('支付失败，请重试')
				}
			})
		},
		changeHandler() {
			this.$emit('addhasToPAyCount',this.hasToPAyCount)
		}
	}
}
</script>

<style lang="less" scoped>
	@import "../assets/styles/askform.less";
</style>
